const palette = {
  special: "linear-gradient(180deg, #FA1515 0%, #F97916 100%);",
  red: "linear-gradient(180deg, #F53636 0%, #D4271C 100%);",
  orange: "linear-gradient(180deg, #FAC215 0%, #F97916 100%);",
  yellow: "linear-gradient(180deg, #FCE838 0%, #EFB520 100%);",
  green: "linear-gradient(180deg, #59C785 0%, #458D2C 100%);",
  blue: "linear-gradient(180deg, #3AB6BC 0%, #3A66BC 100%, #2F508E 100%, #2F508E 100%);",
  navy: "linear-gradient(180deg, #567BDA 0%, #275ABC 48.45%, #0D40A3 100%);",
  purple: "linear-gradient(180deg, #E768EA 0%, #9C12BF 100%);",
  bot: "linear-gradient(180deg, #D9D9D9 0%, #666565 99.99%, rgba(217, 217, 217, 0) 100%);",
};

export default palette;
